'use client';
import { JumboCard, JumboScrollbar } from 'themes/jumbo/@jumbo/components';
import {
  Chip,
  Typography,
  Button,
  Tooltip,
  useTheme
} from '@mui/material';
import { ReportsList } from './components';
import { useSelector } from 'react-redux';
import { FoldersActions } from "actions";
import { useHistory } from 'react-router-dom';
import * as Utils from "services/UtilsService";
import { trackEvent } from "components/Tracking";
import { useState, useEffect } from "react";
import _ from 'utils/@lodash';

const ReportsCard = ({title, filter}:{title:React.ReactNode, filter:string}) => {
	const data = useSelector((state: any) => state.cache.data);
  const projects = data.projects;
  const reportsData: any[] = [];
  const catalog = FoldersActions.getCatalog("0");
  const entities = FoldersActions.getReportHierarchy(catalog);
  const _list = Object.values([...entities]);

  const storeAuthData = useSelector((state: any) => state.auth);
  const { defaultProjects } = storeAuthData;
  //const demoProjectsHidden = Number(localStorage.getItem('hideDemoProjects') || 0) > 0;

  const [list, setList] = useState<any[]>(_list);
  const theme = useTheme();

  useEffect(() => {
    let data = _list
                    .filter((item: any) => !defaultProjects.includes(item.ID))
                    .filter((item: any) => filter !== 'all' ? item.ID === filter : item.ID !== null);
    if (data.length > 0) {
      if (data[0].type === "PROJECT") {
          data = Utils.sortArrayByProp(data, "name");
      } else {
          //Folders and files inside a project must be rendered by folder first, then files. Those must then be ordered by date DESC (newest first).
          const folderList = data.filter((entity: any) => entity.type === "FOLDER");
          const fileList = data.filter((entity: any) => entity.type !== "FOLDER");
          data = Utils.sortArrayByProp(folderList, "date", true, true).concat(
              Utils.sortArrayByProp(fileList, "date", true, true)
          );
      }
    }
    !_.isEqual(data, list) && setList(data);
  }, [_list, list, defaultProjects, filter])

  const history = useHistory();
  const handleClick = (e: any) => {
    trackEvent("Dashboard", "Reports", "Btn_All");
    history.push(`/reports`);
  };

  list.map((entity: any, index: number) => {
    if(!entity) return;
    const { name, type, project:projectID } = entity;
    reportsData.push({
      projectID,
      projectName: projects[projectID]?.name,
      name,
      type,
      hasSubFolders: entity.subFolders ? entity.subFolders.length > 0 : false
    })
  })

  const CardTitle = () => (
    <div style={{display: "flex", justifyContent: 'space-between'}}>
      <div style={{display: "flex", gap: '10px', alignItems: 'center'}}>
        <Typography color={'text.primary'} variant={'h6'} mb={0}>
          {title}
        </Typography>
        <Chip
          size={'small'}
          label={reportsData.length}
          color='success'
          sx={{
            textAlign: 'center',
            backgroundColor: theme.palette.primary.main,
            transform: 'scale(.8)'
          }}
        />
      </div>
      { reportsData.length > 0 && (
        <Tooltip title="All reports" placement="top" arrow>
          <Button
            size={'small'}
            variant={'outlined'}
            onClick={handleClick} 
            style={{height: '25px', minWidth: 'auto'}}
          >
            All
          </Button>
        </Tooltip>
      )}
    </div>
  )

  return (
    <JumboCard
      title={<CardTitle />}
      contentWrapper
      contentSx={reportsData.length > 0 ? { p: 0, minHeight: '75%'} : { p: 0, minHeight: '75%', alignItems: 'center', display: 'flex', width: '100%', justifyContent: 'center'}}
      sx={{height: '325px'}}
    >
      <ReportsList reports={reportsData} />
    </JumboCard>
  );
};

export { ReportsCard };
